<template>
  <template v-if="question?.status !== 'READ_ONLY'">
    <div class="d-flex flex-column waffle-check-label-container">
      <label
          class="mb-2 d-flex waffle-hover-border waffle-check-box-label"
          v-for="(option, index) in question.options"
          :key="index"
          :class="{
            'waffle-invalid-border waffle-invalid-color': error && hasBeenInteractedWith,
            'no-value-checked':!value.length,
            'waffle-check-box-disclaimer': question.type === 'disclaimer-checkbox',
            // checked:value.indexOf(option.value) > -1,
            'justify-content-between align-items-center': shouldPlaceholderWrap }"
      >
        <div v-if="shouldPlaceholderWrap">
          <span class="ms-2 d-block checkbox-title fs-16"  style="align-self: end">
          {{ option.text }}
          </span>
          <span class="ms-2 d-block checkbox-description" style="align-self: end">{{option?.details?.description}}</span>
        </div>
        <input
            v-bind="$attrs"
            type="checkbox"
            :name="question.name"
            :id="`${question.name}-checkbox-${index}`"
            :disabled="disabled"
            style="min-width: 20px;"
            :value="option.value"
            @click.stop="$emit('user-interaction'); setCheckBoxValue(option.value);"
            :checked="value.indexOf(option.value) > -1"
            class="waffle-check-box-input mr-3"
            :class="{'waffle-invalid-color':error && hasBeenInteractedWith,' waffle-invalid-border':error && hasBeenInteractedWith}"
        />
        <div v-if="!shouldPlaceholderWrap">
          <span class="ps-3 d-block checkbox-title"  style="align-self: end">
          {{ option.text }}
          </span>
          <span class="ms-2 d-block checkbox-description" style="align-self: end">{{option?.details?.description}}</span>
        </div>
      </label>
    </div>
    <slot name="helptext" :isConfirm="!disableConfirm && (question.value && question?.prefilled) && !error" :isError="error"
          :confirmCb="() => {$emit('user-interaction'); $emit('confirm');}"></slot>
  </template>

  <ReadOnly
      v-else
      :question="question"
      :value="displayReadOnly"
      :forcePromptPlaceholder="forcePromptPlaceholder"
  />
</template>
<script>
import ReadOnly from "@/components/themeable-components/ReadOnly.vue";

export default {
  name: "CheckBox",
  components: {ReadOnly},
  emits: ["update:modelValue", 'field-error', 'confirm','user-interaction'],
  props: ["question", "modelValue", "hideSubText",'disableConfirm', 'skipEagerValidation','forcePromptPlaceholder','hasBeenInteractedWith','disabled', 'shouldPlaceholderWrap'],
  data() {
    return {
      value: [],
      error: '',
    };
  },
  mounted() {
    const values = this.question.value ? this.question.value?.split(",") : [];
    if (values.length) {
      values.forEach(v => this.setCheckBoxValue(v))
    }

    if (
        (this.question.required &&
            !this.question.value &&
            !this.skipEagerValidation)
    ) {
      this.error = "Required";
      return this.$emit("field-error", true);
    }

    if (this.question.error) {
      this.error = this.question.error
      return this.$emit('field-error', true)
    }

  },
  methods: {
    setCheckBoxValue(v) {
      if ((this.value || []).find(el => el === v)) {
        this.value = this.value.filter(el => el !== v)
      } else if (v) {
        this.value.push(v)
      }
      if (this.question.required && !this.value.length) {
        this.error = 'Required'
        this.$emit("update:modelValue", ' ');
        return this.$emit('field-error', true)
      } else {
        this.error = ''
        this.$emit('field-error', false)
      }
      return this.$emit("update:modelValue", this.value?.join(","));
    },
  },
  watch: {
    question: {
      handler(newVal) {
        const values = newVal?.value?.split(",") ?? [];
        if (newVal?.value?.length) {
          this.$nextTick(() => {
            const newValues = values.reduce((acc, curr) => {
              if(!this.value.find(el => el === curr)){
                acc.push(curr)
              }
              return acc
            }, [])
            const valuesToRemove = this.value.reduce((acc, curr) => {
              if(!values.find(el => el === curr)){
                acc.push(curr)
              }
              return acc
            }, [])

            return [...newValues, ...valuesToRemove].forEach(v => this.setCheckBoxValue(v))
          })
          this.shouldConfirm = false;
        }

        if (newVal.error) {
          this.error = newVal.error
          return this.$emit('field-error', true)
        }
      },
      deep: true
    }
  },
  computed:{
    displayReadOnly(){
      return this.value?.length ? (
          this.value?.map(v=>this.question.options.find(el=> el.value === v)?.text)?.join(',')?.length ?
              this.value?.map(v=>this.question.options.find(el=> el.value === v)?.text)?.join(','):this.value?.join(',')
      ):'-'
    }
  }
};
</script>